import React, { Component } from "react"
import { Link } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import AOS from "aos"
import 'aos/dist/aos.css';
import NewsStrip from "../../components/news-strip";
import mainImg from "../../images/pcv-drivers.jpg";
import driverImg from "../../images/bus-coach-driver-jobs.jpg";
import arrowSvg from "../../images/arrow-circle-right-solid.svg"

class JobsPage extends Component {

  componentDidMount() {
    AOS.init();
    window.addEventListener('load', AOS.refresh);
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000);
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="PCV School Bus Driver Leeds Jobs" description="PCV Driver? Find your next career at Tetley's Coaches - Leeds' oldest coach operator established 1949." />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent page-article headblock">
            <h1 className="headblock__heading">PCV School Bus Driver Leeds</h1>
            <p className="headblock__byline">Find a career with Tetley's Coaches</p>
          </div>
          <div className="body gutter page-article page-content-parent">
            <h2 data-aos='fade-left' data-aos-duration="500" style={{ marginBottom: 20 }}>PCV School Bus Driver – Part Time</h2>
            <div className="page-content">
              <div className="page-content__text" style={{ width: '100%' }}>
                <img src={driverImg} alt="PCV drivers" />

                <p>We’re hiring Part-Time School Bus Drivers for a set Monday–Friday school run. A dedicated vehicle, the same route each day, and a calm, predictable role suited to semi-retired drivers or anyone seeking improved work–life balance.</p>
                <h3>What the Role Involves</h3>
                <br></br>
                <ul>
                  <li>AM & PM school run</li>
                  <li>25/32.5 Hours per week depending on school run allocated</li>
                  <li>Same route each day</li>
                  <li>Same allocated vehicle where possible</li>
                  <li>Overtime available</li>
                </ul>

                <h3>Pay:</h3>
                <br></br>

                <p>💰 <strong>Monday to Friday:</strong> £14.70 per hour</p>
                <p>💰 <strong>Weekend overtime:</strong> £16.25 per hour</p>

                <h3>What You Need:</h3>
                <br></br>
                <ul>
                  <li>Full <strong>PCV (Category D) licence</strong></li>
                  <li>Valid <strong>Driver CPC</strong></li>
                  <li>DBS check (arranged by the company)</li>
                </ul>

                <h3>Benefits:</h3>
                <br></br>
                <p>✔ <strong>SimplyHealth</strong> cashback plan (company funded)</p>
                <p>✔ <strong>Tetley’s Xclusives</strong> retail discounts (1,000+ brands)</p>
                <p>✔ <strong>Discounted rail travel</strong> on FirstGroup services (after 6 months)</p>
                <p>✔ Enhanced holiday pay</p>
                <p>✔ Company pension scheme</p>
                <p>✔ Fully funded CPC training</p>
                <p>✔ Paid medicals</p>
                <p>✔ Modern fleet and smart uniform</p>

                <div id="jobs-apply" style={{ width: '100%', maxWidth: '100%' }} className="page-content__text">
                  <div className="content-box" style={{ width: '100%', maxWidth: '100%' }}>
                    <h3>Apply now</h3>
                    <p>Please complete our online <a href="https://forms.gle/xbR2G7PPAhZPLe7K8">Application form</a>. Applicants may also email a copy of their CV to <a href="mailto:sales@tetleyscoaches.co.uk">sales@tetleyscoaches.co.uk</a> along with a cover letter.</p>
                    <p>Immediate start available.</p>
                    <a href="https://forms.gle/xbR2G7PPAhZPLe7K8" className='btn btn-grow btn-others btn-small btn-jobs-apply'>
                      <span className='btn-others__text'>Apply</span>
                      <img className='btn-others__icon' src={arrowSvg} alt="" />
                    </a>
                  </div>
                </div>

                <p style={{ margin: 0 }}>
                  <Link to="/applicant-privacy-policy/" className="privacy-notice-link">
                    Applicant privacy notice
                  </Link>
                </p>

              </div>

            </div>
          </div>
        </div>

        <NewsStrip />

      </Layout>
    );
  }
}

export default JobsPage
